import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Microphone02 = function Microphone02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20 12v1c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8v-1m8 5c-2.2091 0-4-1.7909-4-4V7c0-2.2091 1.7909-4 4-4s4 1.7909 4 4v6c0 2.2091-1.7909 4-4 4"
    })
  }));
};
export default Microphone02;